import ScrollToTop from '@/components/general/ScrollToTop';
import ContainerBody from '@/components/layout/ContainerBody';
import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { ReactNode, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

interface HomePanelLayoutProps {
    isErrorPage?: boolean,
    children?: ReactNode
}

export default observer(function HomePanelLayout({ children, isErrorPage = false }: HomePanelLayoutProps) {
    // hooks
    const { pathname } = useLocation();

    // store
    const {
        authStore: { getProfile }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getProfile();
    }, [pathname]);

    return (
        <>
            {/* Container Body */}
            <ContainerBody
                showHeader={true}
                showFooter={true}
                isErrorPage={isErrorPage}
            >
                {
                    children ?? <Outlet />
                }
            </ContainerBody>

            <ScrollToTop />

        </>
    );
});
